import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKey, Maybe, SeatLimit } from "types/generated";

export type PersonalApiKey = Pick<
  ApiKey,
  "id" | "name" | "description" | "type" | "expiresAt" | "lastUsedAt"
>;

type GetPersonalApiKeys = {
  viewer: Maybe<{ ownedApiKeys: PersonalApiKey[] }>;
  seats: { apiKey: Pick<SeatLimit, "limit" | "inUse"> };
};

export const GET_PERSONAL_API_KEYS: TypedDocumentNode<GetPersonalApiKeys> = gql`
  query GetPersonalApiKeys {
    viewer {
      ownedApiKeys {
        id
        name
        description
        type
        expiresAt
        lastUsedAt
      }
    }
    seats {
      apiKey {
        limit
        inUse
      }
    }
  }
`;
